import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _taggedTemplateLiteral from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AccountController, AssetUtil, EventsController, NetworkController, RouterController, RouterUtil } from '@web3modal/core';
import { customElement } from '@web3modal/ui';
import { LitElement, html } from 'lit';
import { state } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import styles from './styles.js';
let W3mNetworksView = class W3mNetworksView extends LitElement {
  constructor() {
    super();
    this.unsubscribe = [];
    this.caipNetwork = NetworkController.state.caipNetwork;
    this.unsubscribe.push(NetworkController.subscribeKey('caipNetwork', val => this.caipNetwork = val));
  }
  disconnectedCallback() {
    this.unsubscribe.forEach(unsubscribe => unsubscribe());
  }
  render() {
    return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      <wui-grid padding=\"s\" gridTemplateColumns=\"repeat(4, 1fr)\" rowGap=\"l\" columnGap=\"xs\">\n        ", "\n      </wui-grid>\n\n      <wui-separator></wui-separator>\n\n      <wui-flex padding=\"s\" flexDirection=\"column\" gap=\"m\" alignItems=\"center\">\n        <wui-text variant=\"small-400\" color=\"fg-300\" align=\"center\">\n          Your connected wallet may not support some of the networks available for this dApp\n        </wui-text>\n        <wui-link @click=", ">\n          <wui-icon size=\"xs\" color=\"accent-100\" slot=\"iconLeft\" name=\"helpCircle\"></wui-icon>\n          What is a network\n        </wui-link>\n      </wui-flex>\n    "])), this.networksTemplate(), this.onNetworkHelp.bind(this));
  }
  onNetworkHelp() {
    EventsController.sendEvent({
      type: 'track',
      event: 'CLICK_NETWORK_HELP'
    });
    RouterController.push('WhatIsANetwork');
  }
  networksTemplate() {
    const {
      approvedCaipNetworkIds,
      requestedCaipNetworks,
      supportsAllNetworks
    } = NetworkController.state;
    const approvedIds = approvedCaipNetworkIds;
    const requestedNetworks = requestedCaipNetworks;
    const approvedIndexMap = {};
    if (requestedNetworks && approvedIds) {
      approvedIds.forEach((id, index) => {
        approvedIndexMap[id] = index;
      });
      requestedNetworks.sort((a, b) => {
        const indexA = approvedIndexMap[a.id];
        const indexB = approvedIndexMap[b.id];
        if (indexA !== undefined && indexB !== undefined) {
          return indexA - indexB;
        } else if (indexA !== undefined) {
          return -1;
        } else if (indexB !== undefined) {
          return 1;
        }
        return 0;
      });
    }
    return requestedNetworks === null || requestedNetworks === void 0 ? void 0 : requestedNetworks.map(network => {
      var _this$caipNetwork, _network$name, _network$name2;
      return html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        <wui-card-select\n          .selected=", "\n          imageSrc=", "\n          type=\"network\"\n          name=", "\n          @click=", "\n          .disabled=", "\n          data-testid=", "\n        ></wui-card-select>\n      "])), ((_this$caipNetwork = this.caipNetwork) === null || _this$caipNetwork === void 0 ? void 0 : _this$caipNetwork.id) === network.id, ifDefined(AssetUtil.getNetworkImage(network)), (_network$name = network.name) !== null && _network$name !== void 0 ? _network$name : network.id, () => this.onSwitchNetwork(network), !supportsAllNetworks && !(approvedIds !== null && approvedIds !== void 0 && approvedIds.includes(network.id)), "w3m-network-switch-".concat((_network$name2 = network.name) !== null && _network$name2 !== void 0 ? _network$name2 : network.id));
    });
  }
  async onSwitchNetwork(network) {
    const {
      isConnected
    } = AccountController.state;
    const {
      approvedCaipNetworkIds,
      supportsAllNetworks,
      caipNetwork
    } = NetworkController.state;
    const {
      data
    } = RouterController.state;
    if (isConnected && (caipNetwork === null || caipNetwork === void 0 ? void 0 : caipNetwork.id) !== network.id) {
      if (approvedCaipNetworkIds !== null && approvedCaipNetworkIds !== void 0 && approvedCaipNetworkIds.includes(network.id)) {
        await NetworkController.switchActiveNetwork(network);
        RouterUtil.navigateAfterNetworkSwitch();
      } else if (supportsAllNetworks) {
        RouterController.push('SwitchNetwork', _objectSpread(_objectSpread({}, data), {}, {
          network
        }));
      }
    } else if (!isConnected) {
      NetworkController.setCaipNetwork(network);
      RouterController.push('Connect');
    }
  }
};
W3mNetworksView.styles = styles;
__decorate([state()], W3mNetworksView.prototype, "caipNetwork", void 0);
W3mNetworksView = __decorate([customElement('w3m-networks-view')], W3mNetworksView);
export { W3mNetworksView };
//# sourceMappingURL=index.js.map